import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        collections: Yup.array().min(1, t('validation.select.collection')),
    }
}
